<!-- @format -->

<ad-item-tag>
  <div class="contents_block margin-spacing-2_bottom">
    <div class="container_project-info margin-spacing-1_bottom">
      <span
        class="status_label status_label-entry margin-spacing-1_right"
        if="{props.ad.in_entry}"
      ></span>
      <ul class="information_list">
        <li class="information_list-item">
          <span class="information_list-item-title">公募案件ID:</span>
          {props.ad.ad_id}
        </li>
      </ul>
      <!--/.information_list-->

      <div
        class="btn_kininaru { props.ad.in_interest ? 'done' : '' }"
        onclick="{ e => props.onInterest(e, props.idx) }"
      ></div>
    </div>
    <!--/.container_project-info-->
    <h2 class="matter_heading margin-spacing-2_bottom">
      <a onclick="{e=>detail(e,props.ad.ad_id)}">{props.ad.title}</a>
    </h2>

    <p
      if="{props.ad.ad_id == 29}"
      style="padding: 1rem 0; font-weight: bold; color: red"
    >
      ※風俗・アダルト関連のお仕事です。ご理解のある方のみご確認、ご応募をお願いします。
    </p>
    <p
      style="font-size: 1.125rem; margin-bottom: 1rem"
      if="{props.ad.description != ''}"
    >
      <span style="color: #b5b5b5">お仕事に関するコメント：</span>
      {props.ad.description}
    </p>

    <ul
      class="scope_list margin-spacing-2_bottom"
      if="{props.ad.working_scope_names.length >= 1}"
    >
      <li
        class="scope_list-item"
        each="{working_scope_name in props.ad.working_scope_names}"
      >
        <span class="skill_label">{working_scope_name}</span>
      </li>
    </ul>

    <ul class="information_list margin-spacing-1_bottom">
      <li class="information_list-item">
        <span class="information_list-item-title">仕事内容:</span>
        <span each="{work_type_name in props.ad.work_type}">
          {work_type_name}
        </span>
      </li>
      <li class="information_list-item">
        <span class="information_list-item-title">ジャンル・テーマ:</span>
        <span each="{genre_name in props.ad.text_content_genres}">
          {genre_name}
        </span>
      </li>
      <li class="information_list-item">
        <span class="information_list-item-title">掲載予定媒体:</span>
        <span each="{target_media_name in props.ad.target_medias}">
          {target_media_name}
        </span>
      </li>
    </ul>
    <!--/.information_list-->

    <ul class="information_list margin-spacing-1_bottom">
      <li class="information_list-item">
        <span class="information_list-item-title">想定報酬総額:</span>
        <span class="notice">
          <number-format
            number="{props.ad.project_sub_amount_min}"
          ></number-format>
          〜
          <number-format
            number="{props.ad.project_sub_amount_max}"
          ></number-format>
        </span>
        <span class="note">円</span>
      </li>

      <li class="information_list-item">
        <span class="information_list-item-title">1制作物の報酬単価:</span>
        <span class="notice">
          <number-format
            number="{props.ad.reward_unit_price_min}"
          ></number-format>
        </span>
        <span class="note">円（税込）</span>
      </li>

      <li class="information_list-item">
        <span class="information_list-item-title">制作物の数:</span>
        {props.ad.volume}{di.Edilent.cTypeProps(props.ad.text_content_type_group_ids).num}
      </li>
      <li
        class="information_list-item"
        if="{!di.Edilent.isNonCharContentType(props.ad.text_content_type_group_ids)}"
      >
        <span class="information_list-item-title">
          {di.Edilent.cTypeProps(props.ad.text_content_type_group_ids).title}:
        </span>
        <number-format number="{props.ad.char_count_per_post}"></number-format>
        {di.Edilent.cTypeProps(props.ad.text_content_type_group_ids).unit}
      </li>
    </ul>
    <!--/.information_list-->

    <p if="{props.ad.company_type==2}" style="font-size: 1.15rem">
      ※源泉が引かれる前の⾦額が表⽰されております。
    </p>

    <div class="container_schedule-info">
      <ul class="information_list">
        <li class="information_list-item">
          <span class="information_list-item-title">公募期間:</span>
          <strong>
            {(props.ad.open_datetime_from) ? props.ad.open_datetime_from :
            "---"}～{(props.ad.open_datetime_to) ? props.ad.open_datetime_to :
            "---"}
          </strong>
        </li>
        <li class="information_list-item">
          <span class="information_list-item-title">初回提出期限:</span>
          <span class="notice">{props.ad.delivery_hope_datetime}</span>
        </li>
      </ul>
      <!--/.information_list-->
      <div class="suppliers">{props.ad.client_name}</div>
    </div>
    <!--/.container_schedule-info-->
  </div>

  <script>
    import di from "dependeny-injection";
    export default {
      di: di,
      detail(e, ad_id) {
        di.router.push(`/ad/detail/${ad_id}`);
      },
    };
  </script>
</ad-item-tag>
